// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ProposedCountry } from './proposedCountry.zod.ts';
import { ProposedTag } from './proposedTag.zod.ts';
import { ProposedValue } from './proposedValue.zod.ts';

export const ProposedFields = zod.object({
  "countries": zod.array(ProposedCountry),
  "industries": zod.array(ProposedTag),
  "maturity": zod.union([ProposedValue,zod.null()]),
  "name": zod.union([ProposedValue,zod.null()]),
  "partners": zod.array(ProposedTag),
  "summary": zod.union([ProposedValue,zod.null()]),
  "tagline": zod.union([ProposedValue,zod.null()])
});

export type ProposedFields = zod.input<typeof ProposedFields>;
export type ProposedFieldsOutput = zod.output<typeof ProposedFields>;
